
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17 16.44L3.60997 3.05C3.21997 2.66 2.58997 2.66 2.19997 3.05C1.80997 3.44 1.80997 4.07 2.19997 4.46L4.99997 7.27V21C4.99997 22.1 5.89997 23 6.99997 23H17C18.02 23 18.85 22.23 18.98 21.25L20 22.27C20.39 22.66 21.02 22.66 21.41 22.27C21.8 21.88 21.8 21.25 21.41 20.86L19 18.44L17 16.44ZM6.99997 19V9.27L16.73 19H6.99997ZM17 5V13.61L19 15.61V3C19 1.9 18.1 1 17 1H6.99997C6.28997 1 5.66997 1.37 5.31997 1.93L8.38997 5H17Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-mobile-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconMobileOff

    ```js
    <b-new-b-icon-mobile-off />
    ```
</docs>


